import { render, staticRenderFns } from "./RPMVObjectivesChart.vue?vue&type=template&id=470a0c0e&"
import script from "./RPMVObjectivesChart.vue?vue&type=script&lang=js&"
export * from "./RPMVObjectivesChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports